import { compile } from '../path-to-regexp/pathToRegexp.tsx';

export const generatePath = (
	pattern = '/',
	params?: { [paramName: string]: string | number | boolean | null | undefined },
): string => (pattern === '/' ? pattern : compile(pattern)(params));
